import React from 'react'
import './Loader.scss'

const Loader = (props) => (
  <div className="loader" style={{ marginTop: '150px' }}>
    <div>
      <div>
        <div>
          <div>
            <div>
              <div />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Loader
